var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recipes-title-bar"},[_c('div',{staticClass:"title"},[_c('h1',[_vm._v(_vm._s(_vm.headingTitle))]),(_vm.count)?_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.count)+" Results")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }